import React from "react";

function ProfileUser() {
  return <div>ProfileUser</div>;
}

export default ProfileUser;
